import { render, staticRenderFns } from "./sample2.vue?vue&type=template&id=e8925906&lang=pug&"
import script from "./sample2.vue?vue&type=script&lang=js&"
export * from "./sample2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8925906')) {
      api.createRecord('e8925906', component.options)
    } else {
      api.reload('e8925906', component.options)
    }
    module.hot.accept("./sample2.vue?vue&type=template&id=e8925906&lang=pug&", function () {
      api.rerender('e8925906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sample/sample2.vue"
export default component.exports